import { ref } from 'vue';
import apiService from '../apiService';

export default function useSessionManagement() {
  const sessionsList = ref([]);
  const isLoading = ref(false);
  const error = ref(null);
  const editingSession = ref(null);
  const isFormOpen = ref(false);
  const formMode = ref('add'); // 'add' or 'edit'
  const adminPassword = ref('');

  const fetchSessions = async () => {
    isLoading.value = true;
    error.value = null;
    try {
      const data = await apiService.WorkspaceSessions();
      // Accepts either { data: [...] } or just [...]
      sessionsList.value = Array.isArray(data) ? data : data.data;
      // Sort by date, newest first
      sessionsList.value.sort((a, b) => b.session_date.localeCompare(a.session_date));
    } catch (err) {
      error.value = err.message || 'Failed to fetch sessions';
    } finally {
      isLoading.value = false;
    }
  };

  const openAddForm = () => {
    editingSession.value = null;
    formMode.value = 'add';
    isFormOpen.value = true;
    adminPassword.value = '';
  };

  const openEditForm = (session) => {
    editingSession.value = { ...session };
    formMode.value = 'edit';
    isFormOpen.value = true;
    adminPassword.value = '';
  };

  const closeForm = () => {
    isFormOpen.value = false;
    editingSession.value = null;
    adminPassword.value = '';
  };

  const createSession = async (sessionData) => {
    isLoading.value = true;
    error.value = null;
    try {
      await apiService.createSession(sessionData);
      await fetchSessions();
      closeForm();
    } catch (err) {
      error.value = err.message || 'Failed to create session';
    } finally {
      isLoading.value = false;
    }
  };

  const updateSession = async (sessionId, sessionData) => {
    isLoading.value = true;
    error.value = null;
    try {
      await apiService.updateSession(sessionId, sessionData);
      await fetchSessions();
      closeForm();
    } catch (err) {
      error.value = err.message || 'Failed to update session';
    } finally {
      isLoading.value = false;
    }
  };

  return {
    sessionsList,
    isLoading,
    error,
    editingSession,
    isFormOpen,
    formMode,
    adminPassword,
    fetchSessions,
    openAddForm,
    openEditForm,
    closeForm,
    createSession,
    updateSession
  };
} 